module.exports = __webpack_public_path__ + "img/icon／24xx.e244dd7f.svg";